import { ComplexValue, LoadOptions, Value } from 'app/types-shared';
import { WithMetroLineWrappedComponentProps } from 'app/components/metro-line/types';
import { ImportSetAdminTranslation } from '../constants';
import { ImportSetSectionType } from './metroline/types';
import {
  ImportSetAdminFormState, ImportSetItem, ImportSetItemValidation
} from './types-store';

export interface ImportSetItemWire {
  id?: Value;
  language: Value[];
  importDatabaseId?: number;
  criteriaDomain?: Value;
  importConstraintSet?: Value;
  disabled: string;
}

export interface DuplicateImportSetItemWire {
  value: ImportSetItemWire;
  override: boolean;
}

export interface ImportSetSectionProps {
  actionType: ImportSetActionType;
  importSetItem: ImportSetItem;
  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    };
  };
  locale: string;
  validation: ImportSetItemValidation;
  translation: ImportSetAdminTranslation;
  section: ImportSetSectionType;
  fetching?: boolean;
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
  updateItem: (item: Partial<ImportSetItem>) => void;
  updateValidation: (validation: ImportSetItemValidation) => void;
  resetValidation: (key: string) => void;
  translationAdminAccess: boolean;
  displayError: (errorMessage: string) => void;
}

export type ImportSetSection = ImportSetSectionProps & WithMetroLineWrappedComponentProps<ImportSetSectionType>;

export interface ImportSetContainerProps {
  actionType: ImportSetActionType;
  formState: ImportSetAdminFormState;
  mainLanguage: number;
  validation: ImportSetItemValidation;
  translation: ImportSetAdminTranslation;
  children?: React.ReactNode;
  switchTranslationsToggle: (value: boolean) => void;
  saveImportSet: (item: ImportSetItem) => void;
  duplicateImportSet: () => void;
  deleteImportSet: () => void;
  updateValidation: (validation: ImportSetItemValidation) => void;
  displayError: (errorMessage: string) => void;
}

export interface ImportSetFormProps {
  actionType?: ImportSetActionType;
  formState: ImportSetAdminFormState;
  mainLanguage: number;
  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    };
  };
  section: ImportSetSectionType;
  locale: string;
  translation: ImportSetAdminTranslation;
  translationAdminAccess: boolean;
  saveImportSet: (item: ImportSetItem) => void;
  duplicateImportSet: () => void;
  deleteImportSet: () => void;
  updateItem: (item: Partial<ImportSetItem>) => void;
  changeLanguage: (languageId: number, text: string) => void;
  copyLanguageToAll: (languageId: number, successMessage: string) => void;
  showTranslations: boolean;
  switchTranslationsToggle: (showTranslations: boolean) => void;
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
  updateValidation: (validation: ImportSetItemValidation) => void;
  resetValidation: (key: string) => void;
  displayError: (errorMessage: string) => void;
}

export interface ImportSetLanguageProps extends WithMetroLineWrappedComponentProps<ImportSetSectionType> {
  language: ComplexValue<number>[];
  mainLanguage: number;
  languageOptions: ComplexValue<number>[];
  showTranslations: boolean;
  validation: ImportSetItemValidation;
  translation: ImportSetAdminTranslation;
  section: string;
  switchTranslationsToggle: (value: boolean) => void;
  changeLanguage: (languageId: number, text: string) => void;
  copyLanguageToAll: (languageId: number, successMessage: string) => void;
}

export interface ImportSetStickyHeaderProps {
  actionType: ImportSetActionType;
  importSetItem: ImportSetItem;
  name: string;
  fetching: boolean;
  translation: ImportSetAdminTranslation;
  displayError: (errorMessage: string) => void;
  onSave: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
}

export enum ImportSetActionType {
  add = 'add',
  duplicate = 'duplicate',
  codelikecode = 'codelikecode',
  edit = 'edit'
}
